import { memo, useEffect, useRef, useState } from 'react';
// import { HomePlaceInfo } from '@/store/types';
import { getAssetUrl } from '@/utils/common';
import HotSpot from './components/HotSpot';
import styles from './index.module.scss';
import { useStore } from "@/store";
import { useQueryGetPlaceJson, useQueryLandmark } from '@/services/hooks';
import { HomePlaceInfo, PageMode } from '@/store/types';
import { useTransition, animated } from '@react-spring/web';
import QrCode from '@/components/QrCode';
import HomePlaceDetail from './components/HomePlaceDetail';
import { HomeText } from './config';




const Home = () => {
  const timeRef = useRef<any>(null);
  const { data: placeData } = useQueryGetPlaceJson();
  const [originalData, setOriginalData] = useState<HomePlaceInfo[]>([])
  const [countRef, setCountRef] = useState<any>(true);
  const { data } =  useQueryLandmark();
  const mode = useStore((state) => state);

  const transitions = useTransition(originalData, {
    keys: (item) => item?.entity_id,
    from: { scale: 0, opacity: 0 },
    enter: { scale: 1, opacity: 1 },
    leave: { scale: 0, opacity: 0 },
    config: { tension: 180 * 2, friction: 12 },
    trail: 100,
  });

  const getRandomItems = (data: any) => {
    const rotation: any = {};
    data?.forEach((ele: any) => {
      const rotationTag = ele?.tags?.filter((item: any) => item.includes('首页轮播'))?.[0];
      if (!rotation[rotationTag]) {
        rotation[rotationTag] = [];
      }
      rotation[rotationTag].push(ele);
    });
    const authorsArray = Object.entries(rotation).map(([number, content]) => ({
      number,
      content
    })).sort((a: any, b: any) => a.number.match(/\d+$/)?.[0] - b.number.match(/\d+$/)?.[0])
    return authorsArray;
  };

  const startRandomDataFetching = (list: any) => {
    let count = 0;
    const randomItems: any = getRandomItems(list);
         
    const interval = 5000;
    const fetchData = () => {            
      setOriginalData(randomItems?.[count]?.content);
      count++;
      if (count > randomItems.length) {
        count = 0;
      }
    };
    setOriginalData(list);
    fetchData(); // 立即执行一次
    timeRef.current = setInterval(fetchData, interval);
  };
  useEffect(() => {
    if (data && data.length > 0) {
      const list = data.map((item: any) => {
        const res = placeData.filter((itm: any) => itm.name === item.name)[0];        
        if (res) {
          return {
            ...res,
            ...item,
          }
        }
      }).filter(item => item !== undefined);
      
      startRandomDataFetching(list);
    }
    if (mode.mode !== PageMode.HOME) {
      clearInterval(timeRef.current);
      timeRef.current = null;
    }
    return () => clearInterval(timeRef.current);
  },[data])
  const HighlightNumbers = (text: string) => {
    const parts = text?.split(/(\d+)/).filter(Boolean) || [];
    return (
      <div>
        {parts.map((part, index) => (
          // 如果是数字，则用<span>包裹并应用样式
          <span key={index} style={{ 
            fontSize: part.match(/^\d+$/) ? '34px' : '33px',
            backgroundColor: part.match(/^\d+$/) ? 'rgba(255, 255, 255, 0.6)' : '',
            borderRadius: part.match(/^\d+$/) ? '34px' : '0',
            fontWeight: part.match(/^\d+$/) ? '800' : '400',
          }}>
            {part}
          </span>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.top_title}>
        {HighlightNumbers(HomeText)}
      </div>
      {transitions((style, place, _, index) => (
        <animated.div
          key={place.entity_id}
          style={{
            position: 'absolute',
            ...style,
            x: place.x,
            y: place.y,
          }}
        >
          <HotSpot place={place} index={index} />
        </animated.div>
      ))}
      <QrCode />
      <HomePlaceDetail />

    </div>
  );
};

export default memo(Home);
